/** SA-1093: the words of HTML email in the Inbox, in one place. */
export const HTML_NOT_KEPT_TOO_LARGE = 'HTML version not kept: over 10 MiB'
export const HTML_NOT_KEPT = 'HTML version not kept'
export const SHOW_AS_TEXT = 'Show as text'
export const SHOW_AS_HTML = 'Show as HTML'
export const DOWNLOAD_EXTERNAL_IMAGES = 'Download External Images'
export const BLOCK_EXTERNAL_IMAGES = 'Block external images'
export const HTML_LOADING = 'Loading…'
export const FRAME_TITLE = 'Email'
